export type PopoverSide = 'bottom' | 'top' | 'right' | 'left'
export type PopoverAlign = 'start' | 'center' | 'end'

type Rect = Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left' | 'width' | 'height'>
type Size = { width: number; height: number }

const SIDES: PopoverSide[] = ['bottom', 'top', 'right', 'left']
const ALIGNS: PopoverAlign[] = ['end', 'start', 'center']

const contentRect = (trigger: Rect, content: Size, side: PopoverSide, align: PopoverAlign, inset: number) => {
  let top: number
  let left: number
  if (side === 'bottom' || side === 'top') {
    top = side === 'bottom' ? trigger.bottom : trigger.top - content.height
    if (align === 'start') left = trigger.left + inset
    else if (align === 'end') left = trigger.right - inset - content.width
    else left = trigger.left + (trigger.width - content.width) / 2
  } else {
    left = side === 'right' ? trigger.right : trigger.left - content.width
    if (align === 'start') top = trigger.top + inset
    else if (align === 'end') top = trigger.bottom - inset - content.height
    else top = trigger.top + (trigger.height - content.height) / 2
  }
  return { top, left, bottom: top + content.height, right: left + content.width }
}

export const pickPopoverPlacement = ({
  trigger,
  content,
  viewport,
  align,
  inset = 0,
  margin = 8,
}: {
  trigger: Rect
  content: Size
  viewport: Size
  align: PopoverAlign
  inset?: number
  margin?: number
}) => {
  const aligns = [align, ...ALIGNS.filter((a) => a !== align)]
  let best = { side: SIDES[0]!, align }
  let leastOverflow = Infinity

  for (const side of SIDES) {
    for (const a of aligns) {
      const rect = contentRect(trigger, content, side, a, inset)
      const overflow =
        Math.max(0, margin - rect.top) +
        Math.max(0, margin - rect.left) +
        Math.max(0, rect.bottom - (viewport.height - margin)) +
        Math.max(0, rect.right - (viewport.width - margin))
      if (overflow === 0) return { side, align: a }
      if (overflow < leastOverflow) {
        leastOverflow = overflow
        best = { side, align: a }
      }
    }
  }
  return best
}
